import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

type DeleteAPIParams = {
  reasonForDeletion?: string;
  improvementFeedback?: string;
};

const apiUrl = resolveApiUrl(`/my-account/delete/${window.SCHA.user.uid}`);

export const deleteMyAccount = async (data: DeleteAPIParams): Promise<any> => {
  const response = await fetch(apiUrl, {
    body: JSON.stringify(data),
    credentials: "same-origin",
    mode: "cors",
    referrer: "no-referrer",
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  if (!response.ok) {
    throw new Error("Error status: " + response.status + ", please try again");
  }

  return response;
};
